var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18.5,
    cy: 18.5,
    r: 18,
    fill: "#FEFEFE",
    stroke: "#BCBCBC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.2447 9.40179L23.2447 9.40178C24.4468 8.19947 26.396 8.19939 27.5983 9.40165C28.8005 10.6038 28.8005 12.5528 27.5984 13.7551L27.952 14.1086L27.5984 13.7551L27.0602 14.2934L22.7066 9.9399L23.2447 9.40179ZM11.2946 21.3532L20.9389 11.7078L25.2925 16.0613L15.6483 25.7066L16.0019 26.0601L15.6483 25.7066C15.3073 26.0476 14.8784 26.2873 14.4092 26.3991C14.4092 26.3991 14.4091 26.3991 14.4091 26.3991L9.80796 27.4946C9.72344 27.5147 9.63462 27.4895 9.57326 27.4282L9.57317 27.4281C9.51188 27.3668 9.4867 27.278 9.50681 27.1935C9.50681 27.1935 9.50682 27.1935 9.50682 27.1935L10.6024 22.592C10.7141 22.123 10.9537 21.6942 11.2946 21.3532C11.2946 21.3532 11.2946 21.3532 11.2946 21.3532Z",
    fill: "#585858",
    stroke: "#585858"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditButton);
export default __webpack_public_path__ + "static/media/EditButton.c64cb7a4a13e33a870e3dfdad0b300cc.svg";
export { ForwardRef as ReactComponent };